import React, { useState } from 'react';
import { Menu, X, Facebook, Instagram, PhoneIcon } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [{
    name: 'About',
    href: '/#about'
  }, {
    name: 'Services',
    href: '/#services'
  }, {
    name: 'Testimonials',
    href: '/#testimonials'
  }];
  return <nav className="fixed w-full bg-sum-light shadow-sm z-50" data-id="element-137">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-138">
        <div className="flex justify-between h-20" data-id="element-139">
          <div className="flex-shrink-0 flex items-center" data-id="element-140">
            <a href="/" data-id="element-141">
              <img className="h-14 w-auto" src="https://cdn.magicpatterns.com/uploads/6cUEwm9nWDESrDmpRk3ub3/sum_logo.jpg" alt="SalesUp Marketing Logo" data-id="element-142" />
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-143">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sum-charcoal hover:text-sum-green font-medium transition-colors" data-id="element-144">
                {link.name}
              </a>)}
            <div className="flex items-center space-x-3 border-l border-gray-300 pl-6" data-id="element-145">
              <a href="https://www.facebook.com/me/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-sum-green transition-colors" data-id="element-146">
                <Facebook size={20} data-id="element-147" />
              </a>
              <a href="https://www.instagram.com/salesupmarketing?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-sum-green transition-colors" data-id="element-148">
                <Instagram size={20} data-id="element-149" />
              </a>
            </div>
            <a href="tel:3058779092" className="flex items-center bg-sum-gold text-sum-charcoal px-5 py-2.5 rounded-md font-semibold hover:bg-yellow-500 transition-colors shadow-sm" data-id="element-150">
              <PhoneIcon size={16} className="mr-2" data-id="element-151" />
              Call Me
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-152">
            <button onClick={() => setIsOpen(!isOpen)} className="text-sum-charcoal hover:text-sum-green focus:outline-none" data-id="element-153">
              {isOpen ? <X size={28} data-id="element-154" /> : <Menu size={28} data-id="element-155" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-sum-light border-t border-gray-100 shadow-lg absolute w-full" data-id="element-156">
          <div className="px-4 pt-2 pb-6 space-y-1 sm:px-3 flex flex-col" data-id="element-157">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="block px-3 py-3 text-base font-medium text-sum-charcoal hover:text-sum-green hover:bg-gray-50 rounded-md" data-id="element-158">
                {link.name}
              </a>)}
            <div className="flex items-center space-x-4 px-3 py-3" data-id="element-159">
              <a href="https://www.facebook.com/me/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-sum-green transition-colors" data-id="element-160">
                <Facebook size={22} data-id="element-161" />
              </a>
              <a href="https://www.instagram.com/salesupmarketing?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-sum-green transition-colors" data-id="element-162">
                <Instagram size={22} data-id="element-163" />
              </a>
            </div>
            <a href="tel:3058779092" onClick={() => setIsOpen(false)} className="flex items-center justify-center px-3 py-3 mt-4 text-center text-base font-bold text-sum-charcoal bg-sum-gold rounded-md hover:bg-yellow-500" data-id="element-164">
              <PhoneIcon size={18} className="mr-2" data-id="element-165" />
              Call Me
            </a>
            <a href="/#contact" onClick={() => setIsOpen(false)} className="block px-3 py-3 mt-2 text-center text-base font-bold text-white bg-sum-green rounded-md hover:bg-green-700" data-id="element-166">
              Contact Me
            </a>
          </div>
        </div>}
    </nav>;
}